import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Compact Diwali sale card (shared), in the style of the dashboard promo cards: diya icon, "Beat22 Diwali Sale" with the
 * offer and dates, and the sale countdown on one line ("Sale starts in" before the sale, "Sale ends in" during it).
 * Usage: <ipm-diwali-sale-card [startAt]="..." [endAt]="..."></ipm-diwali-sale-card>
 */
@Component({
  selector: 'ipm-diwali-sale-card',
  templateUrl: './diwali-sale-card.component.html',
  styleUrls: ['./diwali-sale-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiwaliSaleCardComponent {
  @Input() startAt: string | null = null;
  @Input() endAt: string | null = null;
  @Input() beatOffer: string = '50%';
}
